import React from 'react'
import { Group, Rect, Text } from 'react-konva'
import type { Coordinate, UnitData } from '../types'
import { BANK_OFFSET_X, BANK_OFFSET_Y, BANK_HEIGHT, CARD_WIDTH, CELL_GAP, CELL_SIZE, COLORS } from '../constants'
import { Unit } from './Unit'
import type { ImageMap } from '../hooks/useImageLoader'

interface BankProps {
  grid: UnitData[][]
  images?: ImageMap | null
  onCellMouseDown?: (coord: Coordinate) => void
  onCellMouseEnter?: (coord: Coordinate) => void
  onCellMouseUp?: (coord: Coordinate) => void
  disabled?: boolean
}

// 유닛 그리드를 은행 카드 내부에 배치
const GRID_PAD_X = 90 // "은행" 라벨 오른쪽
const GRID_PAD_Y = 20  // 상단 여백

export function bankCellToPixel(col: number, row: number) {
  return {
    x: BANK_OFFSET_X + GRID_PAD_X + col * (CELL_SIZE + CELL_GAP),
    y: BANK_OFFSET_Y + GRID_PAD_Y + row * (CELL_SIZE + CELL_GAP),
  }
}

export const Bank: React.FC<BankProps> = ({ grid, images, onCellMouseDown, onCellMouseEnter, onCellMouseUp, disabled = false }) => {
  return (
    <Group opacity={disabled ? 0.4 : 1} listening={!disabled}>
      {/* Bank background — Konva Rect */}
      <Rect
        x={BANK_OFFSET_X}
        y={BANK_OFFSET_Y}
        width={CARD_WIDTH}
        height={BANK_HEIGHT}
        fill={COLORS.bankCard}
        cornerRadius={12}
        listening={false}
      />
      {/* "은행" 라벨 (좌측 상단) */}
      <Text
        x={BANK_OFFSET_X + 16}
        y={BANK_OFFSET_Y + 25}
        text="은행"
        fontSize={20}
        fontStyle="bold"
        fontFamily="CookeiRunBold"
        fill="#FFFFFF"
        listening={false}
      />
      {/* 유닛 그리드 */}
      {grid.map((col, ci) =>
        col.map((unit, ri) => {
          const { x, y } = bankCellToPixel(ci, ri)
          return (
            <Unit
              key={`bank-${ci}-${ri}`}
              x={x}
              y={y}
              state={unit.state}
              isEmpty={unit.isEmpty}
              images={images}
              onMouseDown={() => onCellMouseDown?.({ col: ci, row: ri })}
              onMouseEnter={() => onCellMouseEnter?.({ col: ci, row: ri })}
              onMouseUp={() => onCellMouseUp?.({ col: ci, row: ri })}
            />
          )
        }),
      )}
    </Group>
  )
}
